import * as React from 'react';
import { Auth } from '../services';
import { BaseRouteProps } from '../interfaces';

import './MfaCodeEntry.css';
import { LoginResponse } from '../enums';

interface MfaCodeEntryProps extends BaseRouteProps<{}> {
    message: JSX.Element;
    onError: any;
    onChange: any;
}
interface MfaCodeEntryState {
    email: string;
    code: string;
}

export class MfaCodeEntry extends React.Component<MfaCodeEntryProps, MfaCodeEntryState> {
    auth: Auth = new Auth(this.props.history);

    constructor(props: MfaCodeEntryProps) {
        super(props);

        const params = new URLSearchParams(props.location.search);
        const email = params.get('email') || '';
        const code = params.get('code') || '';

        this.state = {
            email: email,
            code: code,
        };
    }

    render() {
        return (
            <div className="auth-container">
                <div className={"auth-body-topper"} />
                {this.props.message}
                <div className={"auth-body set-password-body"}>
                    <div className={"auth-input"}>
                        <div className={"box-icon"}>
                            <span className="glyphicon glyphicon-lock" />
                        </div>
                        <input value={this.state.code} onKeyUp={this.handleKey} className={"box-input"} type="text" name="code" placeholder={"MFA Code"} required={true} onChange={this.changeCode} />
                    </div>
                    <div className={"auth-link-container"}>
                        We have updated our security to include Multi-Factor Authentication. Please enter the code you received via email to log in
                    </div>
                </div>
                <div className="auth-footer" onClick={this.submitCode}>
                    <div className="auth-button">Submit<span className="auth-arrow">></span></div>
                </div>
            </div>);
    }

    handleKey = async (e: any): Promise<void> => {
        if (e.keyCode === 13) {
            e.preventDefault();
            if (this.state.code.length === 6) {
                await this.submitCode();
            }
        }
    }

    changeCode = async (e: any) => {
        const value = e.target.value;
        await this.setState({code: value});
        await this.props.onChange();
    }

    submitCode = async (): Promise<void> => {
        let receipt = this.auth.getMfaAuthenticationReceipt();
        let response = await this.auth.authenticateWithReceiptAndCode(this.state.email, receipt, this.state.code);
        if (response !== LoginResponse.Success) {
            await this.props.onError();
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/MfaCodeEntry.tsx